import { FC, useState } from "react";
import "../../../styles/Home/CTA/CTA.css"
import WhatsApp from "../../../assets/icons/whatsapp.png"
import ChatIcon from "../../../assets/icons/Chat.png"
import PipelineIcon from "../../../assets/icons/Pipelines.png"
import ReimbursementIcon from "../../../assets/icons/Reimbursement.png"
import MeetingIcon from "../../../assets/icons/Meeting.png"
import { useIntl } from "react-intl";

const CTA: FC = () => {
    const intl = useIntl()
    const [windowSize, setWindowSize] = useState<number>(window.innerWidth)

    const WA_NUMBER = "6282330779799";
    const WA_TEXT = "Halo saya tertarik dengan Wooblazz CRM. Apa boleh didemokan dan diinfokan lebih lanjut? _[Compro Wooblazz]_";
    const encodedMessage = encodeURIComponent(WA_TEXT);
    const WA_LINK = `https://api.whatsapp.com/send?phone=${WA_NUMBER}&text=${encodedMessage}`;

    window.addEventListener('resize', () => {
        setWindowSize(window.innerWidth)
    })

    return (
        <div className="p-5 px-4 px-md-5 container-fluid sora">
            <div className="bg-cta mx-auto py-5 position-relative z-2 px-3" style={{ maxWidth: '1200px' }}>
                <h1 className="fw-bold mt-3">
                    {intl.formatMessage({ id: "CTA.HEADER" })}
                </h1>
                <h5 className="mt-2">
                    {intl.formatMessage({ id: "CTA.DESCRIPTION" })}
                </h5>
                <div className="mt-4 mb-3">
                    <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                        <button className="btn btn-jumbotron-orange rounded-pill px-3 px-sm-4 px-md-5 py-3 fw-bold">
                            <div className="d-flex align-items-center">
                                <img src={WhatsApp} alt="WhatsApp" className="me-2 me-sm-3 logo" />
                                <span className="btn-text">
                                    {intl.formatMessage({ id: "CTA.BUTTON" })}!
                                </span>
                            </div>
                        </button>
                    </a>
                </div>

                <img src={ChatIcon} alt="" className="position-absolute img-fluid z-n1 tl" width={64} />
                <img src={MeetingIcon} alt="" className="position-absolute img-fluid z-n1 tr" width={64} />
                <img src={PipelineIcon} alt="" className="position-absolute img-fluid z-n1 bl" width={85} />
                <img src={ReimbursementIcon} alt="" className="position-absolute img-fluid z-n1 br" width={82} />
            </div>
        </div>
    )
}

export { CTA }